import httpRequest from '@/utils/api'
import type {
  CreatePromoCampaignRequest,
  PromoCampaign,
  PromoCampaignListResponse,
  PromoImageUploadResponse,
  UpdatePromoCampaignRequest,
} from '@/types/promo'

enum API {
  campaigns = '/admin/promo/campaigns',
  campaign = '/admin/promo/campaigns/:campaignId',
  uploadImage = '/admin/promo/images',
}

export const getPromoCampaignsAPI = () => {
  return httpRequest.get<PromoCampaignListResponse>({ url: API.campaigns })
}

export const createPromoCampaignAPI = (data: CreatePromoCampaignRequest) => {
  return httpRequest.post<PromoCampaign>({ url: API.campaigns, data })
}

export const updatePromoCampaignAPI = (
  campaignId: number,
  data: UpdatePromoCampaignRequest
) => {
  return httpRequest.put<PromoCampaign>({
    url: API.campaign.replace(':campaignId', String(campaignId)),
    data,
  })
}

/**
 * 上传弹窗整图。
 *
 * 后端按内容哈希命名，换图必然是新 URL —— 不用手动清 CDN 缓存。
 */
export const uploadPromoImageAPI = (file: File) => {
  const formData = new FormData()
  formData.append('file', file)

  return httpRequest.post<PromoImageUploadResponse>({
    url: API.uploadImage,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
